import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { SortIcons, StyledHeaderSort } from './styles';
import { ChevronArrow } from '../ChevronArrow';
export var validateTableHeaders = function (headers) {
  var headersFields = ['title'];
  var missingProps = {};
  headers.forEach(function (columnConfiguration) {
    headersFields.forEach(function (requiredProp) {
      if (!columnConfiguration[requiredProp]) {
        missingProps[requiredProp] = true;
      }
    });
  });
  var listMissingProps = Object.keys(missingProps);
  if (listMissingProps.length > 0) {
    throw new Error("Error: header configuration, missing following props: ".concat(listMissingProps.join(',')));
  }
  return true;
};
export var HeaderSort = function (_a) {
  var title = _a.title,
    field = _a.field,
    sortable = _a.sortable,
    sortBy = _a.sortBy,
    onSortChange = _a.onSortChange;
  var theme = useTheme();
  var isActive = function (direction) {
    return field === sortBy.field && direction === sortBy.direction;
  };
  var getColor = function (direction) {
    if (isActive(direction)) {
      return theme.tokens.accent.base.primary.regular;
    }
    return theme.tokens.interface.neutral.regular;
  };
  var handleClick = function (direction) {
    return function () {
      if (isActive(direction)) {
        return onSortChange === null || onSortChange === void 0 ? void 0 : onSortChange({
          field: '',
          // @ts-expect-error - Needs refactoring.
          direction: ''
        });
      }
      return onSortChange === null || onSortChange === void 0 ? void 0 : onSortChange({
        // @ts-expect-error - Needs refactoring.
        field: field,
        direction: direction
      });
    };
  };
  return _jsxs(StyledHeaderSort, {
    children: [title, sortable && _jsxs(SortIcons, {
      children: [_jsx(ChevronArrow, {
        onClick: handleClick('ASC'),
        isOpen: true,
        fillColor: getColor('ASC')
      }), _jsx(ChevronArrow, {
        onClick: handleClick('DESC'),
        isOpen: false,
        fillColor: getColor('DESC')
      })]
    })]
  });
};
export var TableHeaders = function (props) {
  var headers = props.headers,
    sortBy = props.sortBy,
    onSortChange = props.onSortChange,
    showArrows = props.showArrows,
    showStickyCols = props.showStickyCols;
  if (validateTableHeaders(headers)) {
    var stickyCounter_1 = 0;
    var mappedHeaders = headers.map(function (_a, index) {
      var title = _a.title,
        minWidth = _a.minWidth,
        field = _a.field,
        isSticky = _a.isSticky,
        sortable = _a.sortable;
      var style = {};
      if (minWidth) {
        style.minWidth = minWidth;
      }
      if (showStickyCols && isSticky) {
        style.minWidth = String(minWidth || '150px');
        style.position = 'sticky';
        var getWidth = Number(style.minWidth.replace(/\D/g, ''));
        style.left = stickyCounter_1;
        stickyCounter_1 += getWidth;
      }
      return _jsx("th", {
        style: style,
        children: sortBy ? _jsx(HeaderSort, {
          sortable: sortable,
          title: title,
          field: field,
          sortBy: sortBy,
          onSortChange: onSortChange
        }) : title
      }, "header-".concat(index));
    });
    return _jsxs("tr", {
      children: [mappedHeaders, showArrows && _jsx("th", {}, "header-".concat(mappedHeaders.length))]
    });
  }
  return _jsx("tr", {});
};